<template>
    <div class="home ">
        <div style="display: flex;justify-content: space-between;width: 60vw;align-items: center;">
            <div style="text-align: left;">
                <div style="font-size: 28px;font-weight: bold;color: rgba(24,24,24,1);">{{ zh_en=='zh'?'明星产品':'Star Products' }}</div>
               
                <!-- <div style="font-size: 22px; color: #181818;">基于三百年吴门医药传承让当代大众活出真健康</div> -->
            </div>


            <div style="text-align: right;">
                <LookMore :linkUrl="'/shop'" />
            </div>
        </div>



        <div style="padding: 40px 0;width: 60vw;position: relative;box-sizing: border-box;">

            <div
                style="height: 450px;padding: 35px;box-sizing: border-box;display: flex;justify-content: space-between; position: relative;">
                <div
                    style="width: 45%;height: 100%;;background-color: #fff;position: relative;;display: flex;justify-content: center;align-items: center;">
                    <img src="../../static/images/shopBorder.png" style="width: 100%;height: 100%;" alt="">
                    <img :src="staticUrl + product_list[index].image"
                        style="width: 90%;height: 90%;top: 0;bottom: 0;left: 0;right: 0;margin: auto;position: absolute;"
                        alt="">
                </div>


                <div style="width: 55%;text-align: left;padding-left: 50px;">
                    <div style="color: #8A2E26;font-size: 28px;">
                        {{ index }}
                        {{ product_list[index].title }}
                    </div>
                    <div>
                        {{ product_list[index].abstract }}
                    </div>
                </div>


                <div class="contrl">
                    <div class="left" @click="downindex">{{ left }}</div>
                    <div class="right" @click="upindex">{{ right }}</div>
                </div>
            </div>


        </div>

        <HomeFooter :none="false" />
    </div>
</template>

<script>
import LookMore from '@/components/home/LookMore.vue'
import HomeFooter from '@/components/HomeFooter.vue';

// @ is an alias to /src
export default {
    props: {
        product_list: {
            default: []
        }
    },
    data() {
        return {
            left: '<',
            right: '>',
            index: 0,
            staticUrl: this.STATICURL,

        }
    },
    components: {
        LookMore,
        HomeFooter
    },
    methods: {
        upindex() {
            console.log(this.index);

            if (this.index == this.product_list.length-1) {
                this.index = 0
                return
            } else {

                this.index = this.index + 1
            }

        },
        downindex() {
          
            if (this.index == 0) {
                this.index = this.product_list.length-1
                return
            } else {
                this.index = this.index - 1
            }
        }
    }

}
</script>


<style lang="less" scoped>
.contrl {
    position: absolute;
    display: flex;
    bottom: 40px;
    right: 100px;

    .left {
        width: 32px;
        height: 32px;
        color: #fff;
        background-color: #8A2E26;
        border-radius: 3px;
        margin-right: 10px;
        line-height: 32px;
    }

    .right {
        width: 32px;
        height: 32px;
        color: #fff;
        line-height: 32px;

        background-color: #8A2E26;
        border-radius: 3px;
    }
}

.home {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -50px;
    background-image: url(../../static/images/home2Back.png);
    background-size: 100% 100%;
    padding-bottom: 150px;
}
</style>